import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Card, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { var_api } from "../../../constant";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { useLocation } from "react-router-dom";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable"; // note default import
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";


const QuotationDetails = () => {
  const tableHeaders = [
    "#",
    "Product",
    "Variant",
    "Qty",
    "Gross/Net ",
    "Unit Price",
    "Discount",
    "Tax ",
    "Tax Amount",
    "Total Price",
    "Remarks",
    " Status",
    "Action",
  ];
  const navigate = useNavigate();
const [filteredVariants, setFilteredVariants] = useState([]); // 👈 new state
  const [quotationData, setQuotationData] = useState([]);
  const [productData, setProductData] = useState([]);
  const [variantData, setVariantData] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [initialLoading, setInitialLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
const [showDeleteModal, setShowDeleteModal] = useState(false);
const [deleteId, setDeleteId] = useState(null);
const [showModal, setShowModal] = useState(false);

const [poData, setPoData] = useState([]);
const [showPOView, setShowPOView] = useState(false);
const [pageLoading, setPageLoading] = useState(false);
 const userId = localStorage.getItem("user_id");
  const userName = localStorage.getItem("name");
  const [formData, setFormData] = useState({
    id: null,
    quotation_id: localStorage.getItem("quotation_id") ,
    product_id: "",
    variant_id: "",
    qty: "",
    gross_weight: "",
    net_weight: "",
    unit_price: "",
    discount: "",
    tax_percent: "",
    tax_amount: "",
    total_price: "",
    remarks: "",
    available_status: 1,
  });
const [quotationInfo, setQuotationInfo] = useState({
  quotation_id: "",
  quotation_number: "",
  quotation_date: "",
  added_by: "",
  status: "",
});

  useEffect(() => {
    loadInitialData();
    const savedQuotation = {
    quotation_id: localStorage.getItem("quotation_id") || "",
    quotation_number: localStorage.getItem("quotation_number") || "",
    quotation_date: localStorage.getItem("quotation_date") || "",
    added_by: localStorage.getItem("added_by") || "",
    status: localStorage.getItem("status") || "",
  };

  setQuotationInfo(savedQuotation);
  }, []);

  const loadInitialData = async () => {
    try {
      setInitialLoading(true);
      await fetchQuotationData();
      await fetchProductData();
      await fetchVariantData();
      fetchPOData();
    } catch (err) {
      toast.error("Error loading data");
    } finally {
      setInitialLoading(false);
    }
  };
const [poList, setPoList] = useState([]);
 const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const quotationId = queryParams.get("quotation_id");


const fetchPOData = async () => {
  setPageLoading(true);
  try {
    const quotationNumber = localStorage.getItem("quotation_number");

    // ✅ Fetch all POs
    const res = await axios.get(`${var_api}sa_veemart_po/get`);
    const allData = Array.isArray(res.data) ? res.data : res.data.data || [];

    // ✅ Filter only POs that belong to this quotation ID
    const filteredPO = allData.filter(po => String(po.quotation_id) === String(quotationId));

    // ✅ Update state
    setPoList(allData);
    setPoData(filteredPO);
    setShowPOView(true);

    // ✅ Handle empty case
    if (filteredPO.length === 0) {
      toast.info(`No Purchase Orders found for Quotation #${quotationNumber}`);
    }
  } catch (err) {
    console.error(err);
    toast.error("Failed to fetch Purchase Orders");
  } finally {
    setPageLoading(false);
  }
};
const [agencyData, setAgencyData] = useState([]);

 const fetchAgencyData = async () => {
  try {
    const res = await axios.get(`${var_api}ci_veemart_supplier_master/get`);
    const agencies = Array.isArray(res.data) ? res.data : res.data.data || [];
    setAgencyData(agencies);
  } catch (err) {
    console.error("Failed to fetch suppliers:", err);
    toast.error("Failed to fetch supplier data");
  }
};
const getSupplierName = (id) => {
  const supplier = agencyData.find((a) => a.id === id);
  return supplier ? supplier.supplier_name : "-";
};
 useEffect(() => {
fetchAgencyData();
  
  }, []);


 const fetchQuotationData = async () => {
  try {
    const quotationId = localStorage.getItem("quotation_id");
    const res = await axios.get(`${var_api}sa_veemart_quotation_detail/get`);
    // Filter only the records related to the selected quotation
    const allData = Array.isArray(res.data) ? res.data : res.data.data || [];
    const filteredData = allData.filter(
      (item) => String(item.quotation_id) === String(quotationId)
    );
    setQuotationData(filteredData);
  } catch {
    toast.error("Failed to fetch quotation details");
  }
};


  const fetchProductData = async () => {
    try {
      const res = await axios.get(`${var_api}sa_veemart_product_master/get`);
      setProductData(Array.isArray(res.data) ? res.data : res.data.data || []);
    } catch {
      toast.error("Failed to fetch product data");
    }
  };

  const fetchVariantData = async () => {
    try {
      const res = await axios.get(`${var_api}sa_veemart_variant_master/get`);
      setVariantData(Array.isArray(res.data) ? res.data : res.data.data || []);
    } catch {
      toast.error("Failed to fetch variant data");
    }
  };
// Filter variants when product changes
useEffect(() => {
  if (formData.product_id) {
    const filtered = variantData.filter(v => v.product_id === Number(formData.product_id));
    setFilteredVariants(filtered);
  } else {
    setFilteredVariants([]); // reset if no product chosen
  }
}, [formData.product_id, variantData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };
const confirmDelete = (id) => {
  setDeleteId(id);
  setShowDeleteModal(true);
};
const handleConfirmDelete = async () => {
  try {
    setLoading(true);
    const res = await axios.delete(`${var_api}sa_veemart_quotation_detail/delete/${deleteId}`);
    toast.success(res?.data?.message || "Record deleted successfully!");
    fetchQuotationData(); // Refresh table
  } catch (err) {
    toast.error(err?.response?.data?.message || "Failed to delete record");
  } finally {
    setLoading(false);
    setShowDeleteModal(false);
    setDeleteId(null);
  }
};

  const handleAddClick = () => {
    setFormData({
      id: null,
      quotation_id: localStorage.getItem("quotation_id") || "",
      product_id: "",
      variant_id: "",
      qty: "",
      gross_weight: "",
      net_weight: "",
      unit_price: "",
      discount: "",
      tax_percent: "",
      tax_amount: "",
      total_price: "",
      remarks: "",
      available_status: 1,
    });
    setIsEditMode(false);
    setErrors({});
    setShowModal(true);
  };

  const handleEditClick = (item) => {
    setFormData({ ...item });
    setIsEditMode(true);
    setErrors({});
    setShowModal(true);
  };
const handleDownloadPDF = () => {
  if (!quotationData.length) {
    toast.info("No data available to export!");
    return;
  }

  const supplierName = poData[0]
    ? getSupplierName(poData[0].supplier_id)
    : "N/A";

  const doc = new jsPDF("p", "pt", "a4");
  const marginLeft = 40;
  let y = 40;

  doc.setFontSize(16);
  doc.setFont("helvetica", "bold");
  doc.text("VeeMart Quotation Report", marginLeft, y);
  y += 25;

  doc.setFontSize(11);
  doc.setFont("helvetica", "normal");
  doc.text(`From: VeeMart`, marginLeft, y);
  y += 15;
  doc.text(`To: ${supplierName}`, marginLeft, y);
  y += 15;
  doc.text(`Quotation No: ${quotationInfo.quotation_number}`, marginLeft, y);
  y += 15;
  doc.text(`Quotation Date: ${formatDate(quotationInfo.quotation_date)}`, marginLeft, y);
  y += 20;

  // ✅ Define columns and rows here
  const tableColumn = [
    "#",
    "Product",
    "Variant",
    "Qty",
    "Gross",
    "Net",
    "Unit Price",
    "Discount",
    "Tax %",
    "Tax Amt",
    "Total",
  ];

  const tableRows = quotationData.map((item, idx) => {
    const productName =
      productData.find((p) => p.id === item.product_id)?.product_name || "-";
    const variantName =
      variantData.find((v) => v.id === item.variant_id)?.variant_name || "-";

    return [
      idx + 1,
      productName,
      variantName,
      item.qty,
      item.gross_weight,
      item.net_weight,
      item.unit_price,
      item.discount,
      item.tax_percent,
      item.tax_amount,
      item.total_price,
    ];
  });

  // Add table
  autoTable(doc, {
    head: [tableColumn],
    body: tableRows,
    startY: y,
    theme: "striped",
    headStyles: { fillColor: [40, 116, 166] },
    styles: { fontSize: 9 },
  });

  const finalY = doc.lastAutoTable.finalY + 30;
  const totalAmount = quotationData.reduce(
    (sum, item) => sum + Number(item.total_price || 0),
    0
  );
  doc.setFont("helvetica", "bold");
  doc.text(`Total Amount: ₹${totalAmount.toFixed(2)}`, marginLeft, finalY);

  doc.save(`Quotation_${quotationInfo.quotation_number}.pdf`);
};
const handleDownloadExcel = () => {
  if (!quotationData.length) {
    toast.info("No data available to export!");
    return;
  }

  // Prepare rows
  const rows = quotationData.map((item) => {
    const productName =
      productData.find((p) => p.id === item.product_id)?.product_name || "-";
    const variantName =
      variantData.find((v) => v.id === item.variant_id)?.variant_name || "-";
    return {
      "Quotation Number": quotationInfo.quotation_number,
      "Quotation Date": formatDate(quotationInfo.quotation_date),
      Product: productName,
      Variant: variantName,
      Quantity: item.qty,
      "Unit Price": item.unit_price,
      "Total Amount": item.total_price,
      "Gross/Net": `${item.gross_weight}/${item.net_weight}`,
      "Tax %": item.tax_percent,
      "Tax Amount": item.tax_amount,
    };
  });

  // Create worksheet
  const ws = XLSX.utils.json_to_sheet(rows);

  // Create workbook and append worksheet
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Quotation");

  // Generate buffer
  const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });

  // Save to file
  saveAs(
    new Blob([wbout], { type: "application/octet-stream" }),
    `Quotation_${quotationInfo.quotation_number}.xlsx`
  );
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};
    if (!formData.product_id) newErrors.product_id = "Product is required";
    if (!formData.variant_id) newErrors.variant_id = "Variant is required";
if (!formData.qty) newErrors.qty = "Quantity is required";
  else if (Number(formData.qty) <= 0) newErrors.qty = "Quantity must be greater than 0";

     // ✅ Unit Price validation
  if (!formData.unit_price) {
    newErrors.unit_price = "Unit price is required";
  } else if (isNaN(formData.unit_price) || Number(formData.unit_price) <= 0) {
    newErrors.unit_price = "Enter a valid positive number";
  }

  // ✅ Total Price validation
  if (!formData.total_price) {
    newErrors.total_price = "Total price is required";
  } else if (isNaN(formData.total_price) || Number(formData.total_price) <= 0) {
    newErrors.total_price = "Enter a valid positive number";
  }
    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      toast.warning("Please correct the highlighted fields");
      return;
    }

    try {
      setLoading(true);
      let res;
      if (isEditMode && formData.id) {
        res = await axios.put(`${var_api}sa_veemart_quotation_detail/update/${formData.id}`, formData);
      } else {
        res = await axios.post(`${var_api}sa_veemart_quotation_detail/post`, formData);
      }
      toast.success(res?.data?.message || "Record saved successfully!");
      setShowModal(false);
      fetchQuotationData();
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to save record");
    } finally {
      setLoading(false);
    }
  };
// Format date to dd/mm/yyyy
const formatDate = (dateStr) => {
  if (!dateStr) return "-";
  const date = new Date(dateStr);
  if (isNaN(date)) return dateStr; // fallback if not valid date
  return date.toLocaleDateString("en-GB"); // gives dd/mm/yyyy
};

 
 const filteredData = quotationData.filter((item) => {
  const productName =
    productData.find((p) => p.id === item.product_id)?.product_name?.toLowerCase() || "";
  const variantName =
    variantData.find((v) => v.id === item.variant_id)?.variant_name?.toLowerCase() || "";
  const qty = String(item.qty || "").toLowerCase();
  const gross = String(item.gross_weight || "").toLowerCase();
  const net = String(item.net_weight || "").toLowerCase();
    const tax_percent = String(item.tax_percent || "").toLowerCase();
  const unit_price = String(item.unit_price || "").toLowerCase();
  const total_price = String(item.total_price || "").toLowerCase();

  const remarks = String(item.remarks || "").toLowerCase();

  const query = searchQuery.toLowerCase();

  return (
    productName.includes(query) ||
    variantName.includes(query) ||
    qty.includes(query) ||
    gross.includes(query) ||
    net.includes(query) ||
    remarks.includes(query)||
    tax_percent.includes(query)||
        unit_price.includes(query)||
    total_price.includes(query)

  );
});

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = filteredData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
 const getStatusBadge = (status) => {
    switch (Number(status)) {
      case 0:
        return <span className="badge bg-warning">Pending</span>;
      case 1:
        return <span className="badge bg-success">Approved</span>;
      case 2:
        return <span className="badge bg-danger">Rejected</span>;
      default:
        return <span className="badge bg-light text-dark">Unknown</span>;
    }
  };
  return (
    <>
      <Card>
        <Card.Body>
   <Card className="p-3 mb-3 position-relative">
  <div className="d-flex justify-content-between align-items-center mb-3">
     <h5 className="mb-0">Quotation Details</h5>
 

     {/* 🔙 Back Button */}
     <Button
       variant="outline-primary"
       size="sm"
       onClick={() => navigate("/quotation")}
     >
       <i className="fas fa-arrow-left me-2"></i> Back to Quotation
     </Button>

   </div>

  <Row className="g-3">
    <Col xs="auto">
      <strong>Quotation No:</strong>{" "}
      <span style={{ color: "green", fontWeight: "600" }}>
        {quotationInfo.quotation_number || "-"}
      </span>
    </Col>
    <Col xs="auto">
      <strong>Date:</strong>{" "}
      <span style={{ color: "green", fontWeight: "600" }}>
  {formatDate(quotationInfo.quotation_date)}
</span>

    </Col>
   <Col xs="auto">
  <h6>
    <strong>Added By:</strong>{" "}
    <span style={{ color: "green" }}>{userName || "N/A"}</span>
  </h6>
</Col>

    <Col xs="auto">
      <strong>Status:</strong>{" "}
      <span style={{ color: "green", fontWeight: "600" }}>
        {getStatusBadge(quotationInfo.status)}
      </span>
    </Col>
  </Row>
</Card>



          {initialLoading ? (
            <div className="text-center my-5">
              <div className="spinner-border text-primary" role="status"></div>
              <div>Loading data...</div>
            </div>
          ) : (
            <>
              <div className="d-flex justify-content-end mb-3 gap-2">
          <Button
  variant="success"
  size="sm"
  onClick={() => {
    setShowPOView(true); // open popup immediately
    fetchPOData();       // fetch PO data in background
  }}
  disabled={pageLoading}
>
  
      <i className="fas fa-eye me-2"></i> View PO
  
</Button>


<Button
  variant="danger"
  size="sm"
  onClick={handleDownloadPDF}
>
  <i className="fas fa-file-pdf me-2"></i> Download PDF
</Button>
<Button
  variant="info"
  size="sm"
  onClick={handleDownloadExcel}
>
  <i className="fas fa-file-excel me-2"></i> Export Excel
</Button>


                <input
                  type="text"
                  className="form-control w-auto"
                  placeholder="Search..."
                  value={searchQuery}
                  onChange={(e) => {
                    setSearchQuery(e.target.value);
                    setCurrentPage(1);
                  }}
                />
                <Button variant="secondary" onClick={handleAddClick}>
                  Add
                </Button>
              </div>

              <div className="table-responsive">
                <table className="table ">
                  <thead>
                    <tr>{tableHeaders.map((h, i) => <th key={i}>{h}</th>)}</tr>
                  </thead>
                  <tbody>
                    {paginatedData.length === 0 ? (
                      <tr>
                        <td colSpan="13" className="text-center text-muted py-3">
                          No data found
                        </td>
                      </tr>
                    ) : (
                      paginatedData.map((item, idx) => {
                        const productName =
                          productData.find((p) => p.id === item.product_id)?.product_name || "-";
                        const variantName =
                          variantData.find((v) => v.id === item.variant_id)?.variant_name || "-";
                        return (
                          <tr key={item.id}>
                            <td>{(currentPage - 1) * itemsPerPage + idx + 1}</td>
                            <td>{productName}</td>
                            <td>{variantName}</td>
                            <td>{item.qty}</td>
                            <td>{item.gross_weight}/{item.net_weight}</td>
                            <td>{item.unit_price}</td>
                            <td>{item.discount}</td>
                            <td>{item.tax_percent}</td>
                            <td>{item.tax_amount}</td>
                            <td>{item.total_price}</td>
                            <td>{item.remarks}</td>
                             <td>
                            <span className={`badge ${item.available_status === 1 ? 'bg-success' : 'bg-danger'}`}>
                              {item.available_status === 1 ? 'Active' : 'Inactive'}
                            </span>
                          </td>
                            <td className="text-center">
                                                         <button
                                className="btn shadow btn-xs sharp"
                                style={{ backgroundColor: "#007bff", color: "white" }}
                                onClick={() => handleEditClick(item)}
                                title="Edit"
                              >
                                <i className="fas fa-pencil-alt"></i>
                              </button>
                                 <button
  className="btn shadow btn-xs sharp"
  style={{ backgroundColor: "#f40c17ff", color: "white" }}
  onClick={() => {
    setDeleteId(item.id);
    setShowDeleteModal(true);
  }}
  title="Delete"
>
  <i className="fas fa-trash"></i>
</button>
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>

                <div className="d-flex justify-content-end mt-3">
                  {[...Array(totalPages)].map((_, idx) => (
                    <Button
                      key={idx}
                      variant={currentPage === idx + 1 ? "primary" : "light"}
                      onClick={() => setCurrentPage(idx + 1)}
                      className="me-1"
                    >
                      {idx + 1}
                    </Button>
                  ))}
                </div>
              </div>
            </>
          )}
        </Card.Body>
<Modal
  show={showPOView}
  onHide={() => setShowPOView(false)}
  size="lg"
  centered
>
  <Modal.Header closeButton>
    <Modal.Title>Purchase Orders for Quotation #{quotationInfo.quotation_number}</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {pageLoading ? (
      <div className="text-center my-4">
        <div className="spinner-border text-primary" role="status"></div>
        <div>Loading PO Data...</div>
      </div>
    ) : poData.length === 0 ? (
      <div className="text-center text-muted py-3">
        No Purchase Orders found for this quotation.
      </div>
    ) : (
      <div className="table-responsive">
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>#</th>
              <th>PO Number</th>
              <th>Supplier </th>
              <th>PO Date</th>
            </tr>
          </thead>
          <tbody>
            {poData.map((po, idx) => (
              <tr key={po.id}>
                <td>{idx + 1}</td>
                <td>{po.po_number || "-"}</td>
 <td>{getSupplierName(po.supplier_id)}</td>
                <td>{formatDate(po.po_date)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </Modal.Body>
  <Modal.Footer>
    <Button variant="danger" onClick={() => setShowPOView(false)}>
      Close
    </Button>
  </Modal.Footer>
</Modal>

        {/* Modal */}
        <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
          <Modal.Header closeButton>
            <Modal.Title>{isEditMode ? "Edit Quotation Detail" : "Add Quotation Detail"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handleSubmit}>
              <Row>
    <Col md={6}>
  <Form.Group className="mb-3">
    <Form.Label>
      Product <span className="text-danger">*</span>
    </Form.Label>
    <Select
      name="product_id"
      value={
        productData
          .filter((p) => p.id === Number(formData.product_id))
          .map((p) => ({ value: p.id, label: p.product_name }))[0] || null
      }
      onChange={(selectedOption) => {
        setFormData((prev) => ({
          ...prev,
          product_id: selectedOption ? selectedOption.value : "",
          variant_id: "", // reset variant when product changes
        }));
        // ✅ Clear product error instantly
        setErrors((prev) => ({ ...prev, product_id: "" }));
      }}
      options={productData.map((p) => ({
        value: p.id,
        label: p.product_name,
      }))}
      placeholder="Select Product"
      isClearable
    />
    {errors.product_id && (
      <div className="text-danger small">{errors.product_id}</div>
    )}
  </Form.Group>
</Col>

       
    <Col md={6}>
  <Form.Group className="mb-3">
    <Form.Label>
      Variant <span className="text-danger">*</span>
    </Form.Label>
    <Select
      name="variant_id"
      value={
        filteredVariants
          .filter((v) => v.id === Number(formData.variant_id))
          .map((v) => ({ value: v.id, label: v.variant_name }))[0] || null
      }
      onChange={(selectedOption) => {
        setFormData((prev) => ({
          ...prev,
          variant_id: selectedOption ? selectedOption.value : "",
        }));
        // ✅ Clear variant error instantly
        setErrors((prev) => ({ ...prev, variant_id: "" }));
      }}
      options={filteredVariants.map((v) => ({
        value: v.id,
        label: v.variant_name,
      }))}
      placeholder={
        formData.product_id ? "Select Variant" : "Select Product First"
      }
      isClearable
      isDisabled={!formData.product_id}
    />
    {errors.variant_id && (
      <div className="text-danger small">{errors.variant_id}</div>
    )}
  </Form.Group>
</Col>


            <Form.Group as={Col} md="4" controlId="qty">
  <Form.Label>Quantity</Form.Label>
  <Form.Control
    type="number"
    placeholder="Enter Quantity"
    value={formData.qty}
    onChange={(e) => {
      const qty = e.target.value;
      const unit_price = formData.unit_price || 0;
      setFormData({
        ...formData,
        qty,
        total: qty * unit_price, // auto calculate
      });
    }}
  />
</Form.Group>

<Form.Group as={Col} md="4" controlId="unit_price">
  <Form.Label>Unit Cost</Form.Label>
  <Form.Control
    type="number"
    placeholder="Enter Unit Cost"
    value={formData.unit_price}
    onChange={(e) => {
      const unit_price = e.target.value;
      const qty = formData.qty || 0;
      setFormData({
        ...formData,
        unit_price,
        total: qty * unit_price, // auto calculate
      });
    }}
  />
</Form.Group>

<Form.Group as={Col} md="4" controlId="total">
  <Form.Label>Total</Form.Label>
  <Form.Control
    type="number"
    placeholder="Total"
    value={formData.total}
    readOnly
  />
</Form.Group>

                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Gross Weight</Form.Label>
                    <Form.Control
                      name="gross_weight"
                      value={formData.gross_weight}
                      onChange={handleInputChange}
                      placeholder="Enter gross weight"
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Net Weight</Form.Label>
                    <Form.Control
                      name="net_weight"
                      value={formData.net_weight}
                      onChange={handleInputChange}
                      placeholder="Enter net weight"
                    />
                  </Form.Group>
                </Col>
         
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Discount</Form.Label>
                    <Form.Control
                      name="discount"
                      value={formData.discount}
                      onChange={handleInputChange}
                      placeholder="Enter discount"
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Tax %</Form.Label>
                    <Form.Control
                      name="tax_percent"
                      value={formData.tax_percent}
                      onChange={handleInputChange}
                      placeholder="Enter tax percent"
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Tax Amount</Form.Label>
                    <Form.Control
                      name="tax_amount"
                      value={formData.tax_amount}
                      onChange={handleInputChange}
                      placeholder="Enter tax amount"
                    />
                  </Form.Group>
                </Col>
   
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Remarks</Form.Label>
                    <Form.Control
                      name="remarks"
                      value={formData.remarks}
                      onChange={handleInputChange}
                      placeholder="Enter remarks"
                    />
                  </Form.Group>
                </Col>
                {isEditMode && (
                  <Col md={6}>
                    <Form.Group className="mb-3 d-flex align-items-center gap-2">
                      <Form.Label className="mb-0">
                        {formData.available_status === 1 ? "Active" : "Inactive"}
                      </Form.Label>
                      <Form.Check
                        type="switch"
                        id="active-status-switch"
                        checked={formData.available_status === 1}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            available_status: e.target.checked ? 1 : 0,
                          })
                        }
                        className={formData.available_status === 1 ? "custom-switch-green" : ""}
                      />
                    </Form.Group>
                  </Col>
                )}
              
              </Row>

               <div className="d-flex justify-content-end gap-2">
                {!isEditMode ? (
                  <>
                    <Button variant="secondary" type="submit" disabled={loading}>
                      {loading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          Creating...
                        </>
                      ) : (
                        "Create"
                      )}
                    </Button>
                    <Button
                      variant="danger"
                      type="reset"
                      disabled={loading}
                      onClick={() =>
                        setFormData({
                          id: null,
    quotation_id: localStorage.getItem("quotation_id") ,
    product_id: "",
    variant_id: "",
    qty: "",
    gross_weight: "",
    net_weight: "",
    unit_price: "",
    discount: "",
    tax_percent: "",
    tax_amount: "",
    total_price: "",
    remarks: "",
    available_status: 1,
                        })
                      }
                    >
                      Reset
                    </Button>
                  </>
                ) : (
                  <>
                    <Button variant="warning" type="submit" disabled={loading}>
                      {loading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          Updating...
                        </>
                      ) : (
                        "Update"
                      )}
                    </Button>
                    <Button variant="danger" onClick={() => setShowModal(false)} disabled={loading}>
                      Cancel
                    </Button>
                  </>
                )}
              </div>
            </Form>
          </Modal.Body>
        </Modal>
        <Modal
  show={showDeleteModal}
  onHide={() => setShowDeleteModal(false)}
  centered
>
  <Modal.Header closeButton>
    <Modal.Title>Confirm Delete</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <p>Are you sure you want to delete this record?</p>
  </Modal.Body>
  <Modal.Footer>
    <Button
      variant="secondary"
      onClick={() => setShowDeleteModal(false)}
    >
      Cancel
    </Button>
    <Button
      variant="danger"
      onClick={handleConfirmDelete}
      disabled={loading}
    >
      {loading ? (
        <>
          <span
            className="spinner-border spinner-border-sm me-2"
            role="status"
          ></span>
          Deleting...
        </>
      ) : (
        "Delete"
      )}
    </Button>
  </Modal.Footer>
</Modal>

      </Card>
        <style>{`
        .custom-switch-green .form-check-input:checked {
          background-color: #28a745 !important;
          border-color: #28a745 !important;
        }
      `}</style>
      <ToastContainer />
    </>
  );
};

export default QuotationDetails;
